<template>
    <div>
        <v-select
            inputId="report-type"
            v-model="selectedType"
            :options="validReportTypes"
            :close-on-select="true"
            label="label"
            class="mw-100"
            placeholder="Select a report type"
            v-on:input="$emit('input', selectedType)"
            :reduce="(option) => option.value"
        >
            <template slot="option" slot-scope="option">
                <div class="my-2 py-1">
                    <div class="mb-2">
                        <span class="icon icon-mr align-middle" :class="[option.glyph]"></span>
                        <span class="align-middle">{{ option.label }}</span>
                        <span class="badge badge-info badge-tiny ml-2" v-show="option.isNew">New</span>
                    </div>
                    <div>
                        <p class="mb-0 text-secondary small">
                            {{ option.description }}
                        </p>
                    </div>
                </div>
            </template>
            <template v-slot:selected-option="option">
                <div>
                    <div class="">
                        <span class="icon icon-mr align-middle" :class="[option.glyph]"></span>
                        <span class="align-middle">{{ option.label }}</span>
                    </div>
                </div>
            </template>
            <template slot="no-options">
                <div class="py-2">
                    <span class="text-secondary">No reports available yet.</span>
                </div>
            </template>
        </v-select>
    </div>
</template>

<script>
export default {
    name: "ReportTypeSelector",
    props: {
        value: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            selectedType: this.value,
            reportTypes: [
                {
                    value: "sessionList",
                    label: "Learner Session List",
                    description: `View a list of all learner attempts for the learning experience, with the ability to drill down and view full Learner Results summaries.`,
                    glyph: "icon-glyphicons-basic-notes",
                },    
                {
                    value: "caseCompletion",
                    label: "Completion Report",
                    description: `See which learners have attempted or completed a learning experience. Includes the number of attempts and scores received.`,
                    glyph: "icon-glyphicons-basic-medal",
                },
                {
                    value: "choiceResponse",
                    label: "Choice Response Report",
                    description: `See how learners responded to a choice-based inquiry (e.g. branching, selection, image hotspots) during a learning experience.`,
                    glyph: "icon-glyphicons-basic-stats-bars",
                },
                {
                    value: "textResponse",
                    label: "Text Response Report",
                    description: `View a list of all learner text-based responses.`,
                    glyph: "icon-glyphicons-basic-paragraph-left",
                },
                {
                    value: "timerPerformance",
                    label: "Timer Performance Report",
                    description: `See how learners performed for a given timer. See which learners exceeded time limits.`,
                    glyph: "icon-glyphicons-basic-stopwatch",
                },
            ],
        }
    },
    computed: {
        validReportTypes() {
            return this.reportTypes.filter((r) => !r.isHidden)
        },
    },
    watch: {
        value: function (newValue) {
            this.selectedType = newValue
        },
    },
}
</script>

<style>
</style>